import React, { FC } from "react"
import styled from "styled-components"
import { OneIcon, TwoIcon, ThreeIcon } from "./components"
import Button from "../../ui/activate-cabinet-button"

const sectionBackground = '#f0f3f6'

const SWrapper = styled.div`
  background: ${sectionBackground};
`

const SContent = styled.div`
  max-width: 1220px;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  margin: 0 auto;
  padding: 81px 0;

  @media screen and (max-width: 767px) {
    padding: 40px 20px;
  }
`

const SLink = styled.a`
  text-decoration: underline;
`

const SText = styled.p`
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;

`

const StepsContainerStyle = styled(SContent)`
  width: 100%;
  padding: 0;

  @media screen and (max-width: 1023px) {
    display: flex;
    justify-content: center;
    flex-direction: row;
    padding: 0 69px;
  }

  @media screen and (max-width: 767px) {
    padding: 0;
    margin-top: 32px;
    margin-bottom: 32px;
  }
`

const ContentStepsStyle = styled.div`
  display: flex;
  width: 70%;
  align-items: center;
  justify-items: center;
  margin: 59px 0 28px;

  span {
    width: 9.09%
  }

  hr {
    width: 36.36%;
    border: none;
    border-top: 1px solid #cdd2d6;
  }

  @media screen and (max-width: 1023px) {
    display: inline-flex;
    flex-direction: column;
    width: min-content;
    margin: 0;
    margin-right: 25px;
    align-self: flex-start;

    hr {
      width: 0;
      height: 50px;
      border: none;
      border-right: 1px solid #cdd2d6;
    }
  }

  @media screen and (min-width: 411px) and (max-width: 467px) {
    hr {
      height: 56px;
    }
  }

  @media screen and (min-width: 329px) and (max-width: 410px) {
    hr {
      height: 80px;
    }
  }

  @media screen and (max-width: 328px) {
    hr {
      height: 105px;
    }
  }

  span {
    background: black;
    display: flex;
    border-radius: 50%;
    width: 52px;
    height: 52px;
    justify-content: center;
    align-items: center;
  }
`

const ContentDescriptionStyle = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 69px;

  @media screen and (max-width: 1023px) {
    display: none;

    p {
      margin: 11px 0 !important;
    }
  }

  h4,
  p {
    flex: 1 0 25%;
    margin: 5px;
    text-align: center;
  }

  p {
    margin: 11px 35px;
  }

  div {
    width: 33.333%;
  }
`

const ContentDescriptionMobileStyle = styled(ContentDescriptionStyle)`
  display: flex;
  flex-direction: column ;
  justify-items: flex-start;
  align-items: flex-end;
  margin-bottom: 0;
  width: 100%;

  div:not(:last-child) {
    margin-bottom: 40px;
  }

  @media screen and (max-width: 767px) {
    margin-left: 25px;
    width: fit-content;
  }

  @media screen and (min-width: 576px) and (max-width: 797px) {
    align-items: flex-start;
  }

  @media screen and (min-width: 468px) and (max-width: 797px) {
    margin-bottom: 16px;
  }

  @media screen and (min-width: 300px) and (max-width: 467px) {
    align-items: flex-start;
    margin-bottom: 0px;
    margin-left: 0;
  }

  @media screen and (min-width: 443px) and (max-width: 467px) {
    margin-bottom: 22px;
  }

  @media screen and (min-width: 343px) and (max-width: 442px) {
    margin-bottom: 0px;
  }

  div {
    display: flex;
    flex-direction: column;
    justify-content: start;
    width: 100%;
    position: relative;
    right: 25px;

    @media screen and (max-width: 1023px) {
      right: 0;
      p {
        text-align: initial;
      }
      h4 {
        text-align: initial;
        margin: 0;
      }
    }
  }

  @media screen and (min-width: 1024px) {
    display: none;
  }
`

const Steps: FC = () => {
  return (
    <SWrapper>
      <SContent>
        <h2>Как будет происходить подключение?</h2>
        <StepsContainerStyle>
          <ContentStepsStyle>
            <span>
              <OneIcon />
            </span>
            <hr />
            <span>
              <TwoIcon />
            </span>
            <hr />
            <span>
              <ThreeIcon />
            </span>
          </ContentStepsStyle>
          <ContentDescriptionStyle>
            <div>
              <h4>
                Оформите договор корпоративной пенсионной программы со СберНПФ
              </h4>
              <p>
                Кабинет будет подключен
                <br />
                после заключения договора.
              </p>
            </div>
            <div>
              <h4>
                Запросите подключение личного кабинета у своего клиентского
                менеджера
              </h4>
              <p>
                С вами свяжется менеджер
                <br />
                для уточнения данных.
              </p>
            </div>
            <div>
              <h4>Воспользуйтесь всеми возможностями нашего нового сервиса</h4>
              <p>Воспользуйтесь всеми возможностями личного кабинета.</p>
            </div>
          </ContentDescriptionStyle>
          <ContentDescriptionMobileStyle>
            <div>
              <h4>
                Оформите договор корпоративной пенсионной программы со СберНПФ
              </h4>
              <p>
                Кабинет будет подключен
                <br />
                после заключения договора.
              </p>
            </div>
            <div>
              <h4>
                Запросите подключение личного кабинета у своего клиентского
                менеджера
              </h4>
              <p>
                С вами свяжется менеджер
                <br />
                для уточнения данных.
              </p>
            </div>
            <div>
              <h4>Воспользуйтесь всеми возможностями нашего нового сервиса</h4>
              <p>
                Воспользуйтесь всеми возможностями
                <br />
                личного кабинета.
              </p>
            </div>
          </ContentDescriptionMobileStyle>
        </StepsContainerStyle>
        <Button to="#form-input">Подключить кабинет</Button>
        <SText style={{ marginTop: "32px" }}>
          Кабинет скоро будет доступен. <SLink href="#form-input">Подпишитесь</SLink> на
          уведомление о запуске.
        </SText>
      </SContent>
    </SWrapper>
  )
}

export default Steps
